import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import "./RoleCardTitle.scss";

const IndividualRoleCardTitle = ({ description = "", title }) => (
    <div className="role-card-title">
        <div className="role-card-title__content">
            <div className="role-card-title__icon">
                <Icon type="FontAwesome" glyph="user-duotone" />
            </div>
            <div className="role-card-title__text">
                <p>
                    <span className="-type--large">{title}</span>
                    {description && (
                        <>
                            <br />
                            <span className="-type--small">{description}</span>
                        </>
                    )}
                </p>
            </div>
        </div>
    </div>
);

IndividualRoleCardTitle.propTypes = {
    description: PropTypes.string,
    title: PropTypes.string.isRequired,
};

export default IndividualRoleCardTitle;
